import { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="px-6 py-6 fixed top-0 bg-white z-[100] w-full shadow-md">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        
        {/* LOGO */}
        <div className="flex items-center gap-3">
          <img
            src={require("../assets/images/Balynced-Transparent.png")}
            style={{ height: 44 }}
            alt="logo"
          />
        </div>

        {/* DESKTOP MENU */}
        <nav className="hidden md:flex gap-6 text-sm text-slate-700">
          <a href="#platform" className="hover:underline">Platform</a>
          <a href="#benefits" className="hover:underline">Provider Benefits</a>
          <a href="#integration" className="hover:underline">Integrations</a>
          <a href="#waitlist" className="hover:underline">Partner Access</a>
        </nav>

        {/* MOBILE TOGGLE BUTTON */}
        <button
          className="md:hidden text-slate-800"
          onClick={() => setOpen(!open)}
          aria-label="Toggle Menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            {open ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden mt-4 bg-white shadow-lg rounded-xl p-4 space-y-4 text-slate-700">
          <a onClick={() => setOpen(false)} href="#platform" className="block">Platform</a>
          <a onClick={() => setOpen(false)} href="#benefits" className="block">Provider Benefits</a>
          <a onClick={() => setOpen(false)} href="#integration" className="block">Integrations</a>
          <a onClick={() => setOpen(false)} href="#waitlist" className="block">Partner Access</a>
        </div>
      )}
    </header>
  );
}
